import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'
import styles from './SalesApp.module.scss'

const SalesApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.SALES}
        scope='sales'
        envKey={apps[AppId.SALES].runtimeEnvKey}
        entryPath='./SalesApp'
        url={process.env.REACT_APP_SALES_APP_DEV_PATH}
        cdnUrl={apps[AppId.SALES].cdnUrl}
        appName={apps[AppId.SALES].name}
        className={styles['sales-app-wrapper']}
        appProps={{
          user,
          initialPath: location.pathname,
          history: history,
          appPath: apps[AppId.SALES].path,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)

export { SalesApp }
